import * as tvx from "../lib/tvx-plugin-module.min";
import {
  MSXMenuRoot,
  MSXContentRoot,
  Tools,
  MSXContentItem,
  MSXContentPage,
} from "../lib/tvx-plugin-module.min";

import {
  res_account,
  res_backgroundColor,
  res_blackColor,
  res_email,
  res_email_headline,
  res_password,
  res_password_headline,
  res_sign_in,
  empty_account_avatar,
  res_yellowColor,
  res_login_background,
  SERVER_ADDRESS,
  res_screenify_user,
} from "../static-res";
import {
  coloredText,
  getShowingUserAccount,
  getUserData,
  IS_LOGIN,
  isLogin,
  STORAGE_PREFIX_ID,
} from "../utils";

export function getInputEmail(): string {
  const storageKey = STORAGE_PREFIX_ID + "email";
  console.log("Getting email from storage, key:", storageKey);
  
  // Используем localStorage вместо tvx.Services.storage
  const email = localStorage.getItem(storageKey) || "";
  console.log("Getting email from storage, result:", email);
  console.log("Email length:", email.length);
  console.log("Using localStorage directly");
  
  // Дополнительная проверка всех ключей в localStorage
  console.log("All localStorage keys:", Object.keys(localStorage));
  console.log("All screenify keys:", Object.keys(localStorage).filter(key => key.startsWith('screenify:')));
  
  return email;
}
export function setInputEmail(newInputEmail: string): void {
  console.log("Setting email to storage:", newInputEmail);
  const storageKey = STORAGE_PREFIX_ID + "email";
  console.log("Storage key:", storageKey);
  
  // Очищаем email от лишних пробелов
  const cleanEmail = newInputEmail ? newInputEmail.trim() : "";
  console.log("Clean email:", cleanEmail);
  
  // Используем localStorage вместо tvx.Services.storage
  localStorage.setItem(storageKey, cleanEmail);
  console.log("localStorage setItem called");
  
  // Проверяем, что значение сохранилось
  const savedValue = localStorage.getItem(storageKey) || "";
  console.log("Email saved successfully, verification:", savedValue);
}
export function getInputPassword(): string {
  return localStorage.getItem(STORAGE_PREFIX_ID + "password") || "";
}
export function setInputPassword(newInputPassword: string): void {
  console.log("Setting password to storage:", newInputPassword ? "[HIDDEN]" : "[EMPTY]");
  // Пароль не обрезаем, так как пробелы могут быть частью пароля
  localStorage.setItem(STORAGE_PREFIX_ID + "password", newInputPassword || "");
}

export function clearLoginInputs(): void {
  console.log("Clearing login inputs");
  localStorage.setItem(STORAGE_PREFIX_ID + "email", "");
  localStorage.setItem(STORAGE_PREFIX_ID + "password", "");
}

export function debugStorage(): void {
  console.log("=== STORAGE DEBUG ===");
  console.log("localStorage available:", typeof localStorage !== 'undefined');
  console.log("localStorage length:", localStorage.length);
  console.log("All localStorage keys:", Object.keys(localStorage));
  console.log("All screenify keys:", Object.keys(localStorage).filter(key => key.startsWith('screenify:')));
  console.log("Email:", localStorage.getItem(STORAGE_PREFIX_ID + "email") || "NOT_FOUND");
  console.log("Password:", localStorage.getItem(STORAGE_PREFIX_ID + "password") ? "[HIDDEN]" : "NOT_FOUND");
  console.log("Is Login:", localStorage.getItem(STORAGE_PREFIX_ID + "is_login") === "true");
  console.log("User Data:", localStorage.getItem(STORAGE_PREFIX_ID + "userData") || "NOT_FOUND");
  console.log("Current domain:", window.location.hostname);
  console.log("Current origin:", window.location.origin);
  console.log("===================");
}

// Функция для тестирования из консоли
export function testEmailSave(email: string): void {
  console.log("Testing email save with:", email);
  setInputEmail(email);
  debugStorage();
  updateInputItem("email");
  
  // Принудительно обновляем контент
  setTimeout(() => {
    console.log("Forcing content reload...");
    tvx.InteractionPlugin.executeAction("reload:content");
  }, 500);
}

// Функция для тестирования сохранения в localStorage напрямую
export function testDirectEmailSave(email: string): void {
  console.log("Testing direct email save with:", email);
  const storageKey = "screenify:email";
  
  try {
    localStorage.setItem(storageKey, email);
    console.log("Email saved directly to localStorage");
    
    // Проверяем сохранение
    const saved = localStorage.getItem(storageKey);
    console.log("Verification - saved email:", saved);
    
    // Проверяем все ключи
    console.log("All localStorage keys:", Object.keys(localStorage));
    console.log("All screenify keys:", Object.keys(localStorage).filter(key => key.startsWith('screenify:')));
    
    // Обновляем поле
    updateInputItem("email");
  } catch (error) {
    console.error("Error saving to localStorage:", error);
  }
}

// Функция для тестирования localStorage в целом
export function testLocalStorage(): void {
  console.log("=== TESTING LOCALSTORAGE ===");
  console.log("localStorage available:", typeof localStorage !== 'undefined');
  console.log("localStorage length:", localStorage.length);
  
  try {
    // Пробуем сохранить тестовое значение
    localStorage.setItem("test_key", "test_value");
    const retrieved = localStorage.getItem("test_key");
    console.log("Test save/retrieve:", retrieved);
    
    // Удаляем тестовое значение
    localStorage.removeItem("test_key");
    console.log("Test value removed");
    
    // Пробуем сохранить email
    localStorage.setItem("screenify:email", "test@example.com");
    const email = localStorage.getItem("screenify:email");
    console.log("Email test:", email);
    
  } catch (error) {
    console.error("localStorage error:", error);
  }
  
  console.log("=== END TEST ===");
}

// Функция для принудительного обновления страницы логина
export function forceReloadLogin(): void {
  console.log("Force reloading login page...");
  tvx.InteractionPlugin.executeAction("reload:content");
}

// Функция для тестирования открытия поля email
export function testOpenEmailField(): void {
  console.log("Testing email field opening...");
  const currentEmail = getInputEmail();
  console.log("Current email before opening field:", currentEmail);
  
  // Симулируем открытие поля email
  const action = `content:request:interaction:email|${res_email_headline()}|${res_login_background}|${currentEmail.replace("@", "$")}|${res_email_headline()}@${SERVER_ADDRESS}input.html`;
  console.log("Email field action:", action);
  
  tvx.InteractionPlugin.executeAction(action);
}

export function updateInputItem(type: string): void {
  console.log("Updating input item:", type);

  try {
    switch (type) {
      case "email": {
        const email = getInputEmail();
        console.log("Updating email field with value:", email);
        console.log("Email length:", email.length);
        console.log("Email headline:", res_email_headline());
        const titleFooter = email.length === 0 ? res_email_headline() : email;
        console.log("Title footer will be:", titleFooter);
        tvx.InteractionPlugin.executeAction(
          `update:content:login-input-${type}`,
          {
            titleFooter: titleFooter,
          }
        );
        console.log("Email field update action executed");
        break;
      }
      case "password": {
        const password = getInputPassword();
        console.log("Updating password field with value:", password ? "[HIDDEN]" : "[EMPTY]");
        tvx.InteractionPlugin.executeAction(
          `update:content:login-input-${type}`,
          {
            titleFooter: password.length === 0 
              ? res_password_headline() 
              : "•".repeat(password.length),
          }
        );
        break;
      }
      default: {
        console.warn("Unknown input type:", type);
      }
    }
  } catch (error) {
    console.error("Error updating input item:", error);
  }
}

function createLoginPage(): MSXContentPage {
  debugStorage(); // Отладочная информация о storage
  const currentEmail = getInputEmail();
  console.log("Creating login page, current email from storage:", currentEmail);
  
  return {
    headline: res_sign_in(),
    items: [
      {
        type: "default",
        id: "login-input-email",
        title: res_email(),
        layout: "3,2,6,1",
        titleFooter:
          currentEmail.length == 0 ? res_email_headline() : currentEmail,
        color: res_backgroundColor,
        action: `content:request:interaction:email|${res_email_headline()}|${res_login_background}|${currentEmail.replace(
          "@",
          "$"
        )}|${res_email_headline()}@${SERVER_ADDRESS}input.html`,
      },
      {
        type: "default",
        id: "login-input-password",
        title: res_password(),
        layout: "3,3,6,1",
        titleFooter:
          getInputPassword().length == 0
            ? res_password_headline()
            : "•".repeat(getInputPassword().length),
        color: res_backgroundColor,
        action: `content:request:interaction:password|${res_password_headline()}|${res_login_background}|${getInputPassword().replace(
          "@",
          "$"
        )}|${res_password_headline()}@${SERVER_ADDRESS}input.html`,
      },
      {
        type: "teaser",
        title: coloredText(res_blackColor, res_sign_in()),
        layout: "3,4,6,1",
        centration: "title",
        color: res_yellowColor,
        alignment: "center",
        action: "interaction:commit:message:content:sign-in:auth:in",
      },
    ],
  };
}

function createAccountPage(): MSXContentPage {
  const userData = getUserData();
  console.log("Creating account page, userData:", userData);
  
  const avatar =
    userData != null
      ? userData.avatarUrl != null
        ? userData.avatarUrl
        : empty_account_avatar
      : empty_account_avatar;
  const userName =
    userData != null
      ? userData.userName != null
        ? userData.userName
        : res_screenify_user()
      : res_screenify_user();
  return {
    headline: getShowingUserAccount(),
    items: [
      {
        type: "default",
        layout: "0,0,1,1",
        image: avatar,
      },
      {
        type: "default",
        layout: "1,0,4,1",
        title: userName,
        titleFooter: getShowingUserAccount(),
      },
      {
        type: "default",
        layout: "5,0,1,1",
        icon: "logout",
        action: "interaction:commit:message:content:sign-in:auth:out",
      },
    ],
  };
}

export function createLoginRoot(): MSXContentRoot {
  const userIsLoggedIn = isLogin();
  console.log("Creating login root, user is logged in:", userIsLoggedIn);
  
  if (userIsLoggedIn) {
    console.log("Returning account page");
    return {
      type: "list",
      headline: res_account(),
      background: res_login_background,
      flag: "login",
      important: true,
      pages: [createAccountPage()],
    };
  } else {
    console.log("Returning login page");
    return {
      type: "list",
      headline: res_account(),
      background: res_login_background,
      flag: "login",
      important: true,
      pages: [createLoginPage()],
    };
  }
}
